<template>
  <div>
    <el-dialog
    :visible.sync="visible"
    :before-close="handleClose"
    width='800px'
    >
    <div slot="title">
        待办事项
      </div>
    <div class="content">
      <div class="table">
        <template v-for="(todo,index) in tabledata">
        <div class="list-item" :key="index" @click="itemClick(todo.todoType)">{{ todo.message }}</div>
        </template>
        <div class="empty" v-if="tabledata.length<=0">
            暂无待办
        </div>
      </div>
      <el-pagination
          background
          layout="prev, pager, next"
          :current-page="tableparam.page"
          :page-size="tableparam.pageSize"
          @current-change="handleCurrentChange"
          :total="tableparam.total"
        >
      </el-pagination>
    </div>
    
    </el-dialog>
  </div>
  
</template>
<script>
import { api } from "@/request/api";
export default {
  props: ["visible"],
  components: {
    
  },
  data() {
    return {
      tableparam:{
        total: 0,
        page: 1,
        pageSize: 10,
        mobile: "",
      },
      inited:false,
      tabledata: [],
      
    };
  },
  mounted(){
    

  },
  created() {
    var that=this;
    that.$watch('visible', function() {
      if(that.visible)
      {
        this.initdata();
      }
    });
  },
  methods: {
    handleClose: function () {
      this.$emit('close');
    },
    initdata() {
      //列表
      var that=this;
      that.defaultTable(that);
      console.log(that.tabledata);
      that.tableQuery();
      // var that = this;
      // that.tableData=[
      //   {content:'您有3条方案待处理，请点击查看',id:'fa'},
      //   {content:'您有3条消息待处理，请点击查看',id:'xx'},
      //   {content:'您有3条预警待处理，请点击查看',id:'warning'},
      //   {content:'您有3条系统消息待处理，请点击查看',id:'systemNews'},
      //   {content:'您有3条饮食解读待处理，请点击查看',id:'diet'}
      // ];
    },
    tableQuery() {
      console.log(8889);
      //列表
      var that = this;
      var parameter = {
        mobile: that.tableparam.mobile,
        page: that.tableparam.page,
        pageSize: that.tableparam.pageSize,
      };
      console.log('that.tableparam1',that.tableparam);
      api.todoQuery(parameter).then((response) => {

        response = response.data;
        if (response.code == 0) {
          that.tableparam.total = response.data.count;
          that.tabledata = response.data.userTodoLists;
        }
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.tableparam.page = cpage;
      this.tableQuery();
    },
    itemClick(id){
      if(id==this.user.todoType.SCHEME){
        this.notificationCenter.postNotificationName('openZsfaRecordListDialog',{status:1});
      }
      else if(id==this.user.todoType.WARNING){
        this.notificationCenter.postNotificationName('openWarningRecordListDialog',{status:1});
      }
      else if(id==this.user.todoType.SYSTEM){
        this.notificationCenter.postNotificationName('openSystemNewsListDialog',{status:1});
      }
      else if(id==this.user.todoType.DIET){
        this.notificationCenter.postNotificationName('openDietRecordListDialog',{status:1});
      }
      else if(id==this.user.todoType.MSG){
        this.notificationCenter.postNotificationName('openNewsRecordListDialog',{status:1});
      }
    }
  },
};
</script>
<style lang="less" scoped="scoped">
/deep/.el-dialog__body
{
  padding:0;
}
.list-item{
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.empty{
  display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}
.content{
    padding: 0;
    padding-bottom: 30px;
}
.table{
  height: 500px;
  overflow: scroll;

}
</style>
